(function() {
    "use strict";

    setCollectionHovers();
    setOverlayToggles();

    function setOverlayToggles() {
        const navToggle = document.getElementById("nav-overlay-toggle"),
            searchInput = document.getElementById("search-input"),
            searchToggles = document.querySelectorAll(".search-toggle"),
            searchOverlay = document.getElementById("search-overlay"),
            mainContent = document.getElementById("MainContent"),
            searchOpenClass = "search-overlay__wrap--open",
            bodyFreezeClass = "lop-overlay__body--freeze",
            headerMenu = document.querySelector('.header__menu-check');

        navToggle.addEventListener("change", function(evt) {
            if (navToggle.checked) {
                window.scrollTo(0, 0);
                document.body.classList.add(bodyFreezeClass);
            } else if(!headerMenu.checked){
                document.body.classList.remove(bodyFreezeClass);
            }
        });

        Array.prototype.forEach.call(searchToggles, function(elem) {
            elem.addEventListener("click", function() {
                if (searchOverlay.classList.contains(searchOpenClass)) {
                    searchOverlay.classList.remove(searchOpenClass);
                    mainContent.style.display='inline';
                    if(!headerMenu.checked){
                        document.body.classList.remove(bodyFreezeClass);
                    }
                    if(!headerMenu.checked){
                        document.body.classList.remove(bodyFreezeClass);
                    }
                } else {
                    window.scrollTo(0, 0);
                    document.body.classList.add(bodyFreezeClass);
                    searchOverlay.classList.add(searchOpenClass);
                    //display none to help with IE and it makes autofocus work?
                    mainContent.style.display='none';
                    searchInput.focus();
                }
            });
        });
    }

    // TODO (performance): change this to hover on the top-level ul and then check the target for the individual elements
    // TODO (performance): build map of links-to-productsets for caching
    function setCollectionHovers() {
        const collectionLinks = document.querySelectorAll(".nav-overlay__collection-name");

        let activeLink = null;
        let activeCollection = null;
        let activeProducts = null;
        Array.prototype.forEach.call(collectionLinks, function(link) {
            link.addEventListener("mouseover", function() {
                if (activeLink === link) {
                    return;
                }
                activeLink = link;

                if (activeCollection) {
                    activeCollection.classList.remove("nav-overlay__collection-products--visible");
                }

                activeCollection = link.parentNode.querySelector(
                    ".nav-overlay__collection-products"
                );
                if (!activeCollection) {
                    return;
                }

                const images = activeCollection.querySelectorAll("img");
                Array.prototype.forEach.call(images, function(img) {
                    if (!img.src) {
                        img.src = img.dataset.src;
                    }
                });
                activeCollection.classList.add("nav-overlay__collection-products--visible");

                if (activeProducts) {
                    toggleFloating(activeProducts);
                }
                activeProducts = activeCollection.querySelectorAll(".nav-overlay__item-img-wrap");
                toggleFloating(activeProducts);

                window.floatInit();
            });
        });
    }

    function toggleFloating(products) {
        Array.prototype.forEach.call(products, function(product) {
            product.classList.toggle("floating-anim");
        });
    }
})();
